import { useState, type FormEvent } from 'react';
import { Button, Dialog, Field, Input } from '@/components/ui';
import { lastRoom, rememberRoom } from './room-store';

/** Which room the patient is called to (shown on the waiting-room screen). */
export function RoomDialog({
  open,
  title,
  onClose,
  onConfirm,
  busy,
  branchName,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onConfirm: (room: string) => void;
  busy?: boolean;
  /** The branch whose queue is called (RL-2176): the call never crosses branches. */
  branchName?: string;
}) {
  const [room, setRoom] = useState(lastRoom);
  function submit(e: FormEvent) {
    e.preventDefault();
    const r = room.trim();
    if (!r) return;
    rememberRoom(r);
    onConfirm(r);
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      variant="modal"
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            form="room-form"
            variant="primary"
            loading={busy}
            disabled={!room.trim()}
          >
            Call
          </Button>
        </>
      }
    >
      <form id="room-form" onSubmit={submit}>
        <Field
          label="Room"
          hint={
            branchName
              ? `Calls the next waiting patient at ${branchName}. Shown on the waiting-room screen with the number.`
              : 'Shown on the waiting-room screen with the number.'
          }
        >
          <Input
            value={room}
            onChange={(e) => setRoom(e.target.value)}
            placeholder="Room 1"
            autoFocus
          />
        </Field>
      </form>
    </Dialog>
  );
}
